import DatabaseModel from './DatabaseModel.js';

var Comunidad = Object.create(DatabaseModel);

Comunidad.model = 'comunidad';
Comunidad.modelFront = 'comunidades';

export default Comunidad;